import { memo } from 'react';

import { List } from '../../../List/List';
import { useComponentMixed } from '../../../utils/useComponentMixed';
import { isSvpCategory } from '../../../../modules/helpers';
import { AssetItem } from '../../common/AssetItem/AssetItem';
import { CategoryItem } from '../../common/CategoryItem/CategoryItem';
import { useAssetItemTracking } from '../../common/useAssetItemTracking';
import { useCategoryItemTracking } from '../../common/useCategoryItemTracking';

import type { MixedListComponent } from '@vgtv/api-client/lib/component/list';
import type { FC } from 'react';

import * as styles from './MixedList.module.scss';

type Props = {
  componentConfig: MixedListComponent;
  pageComponentIndex: number;
};

const MixedListBase: FC<Props> = ({ componentConfig, pageComponentIndex }) => {
  const { id, header } = componentConfig;

  const mixed = useComponentMixed(id);

  const { trackAssetClick } = useAssetItemTracking({
    elementType: 'MixedList',
    header: componentConfig.header,
    pageComponentIndex,
  });

  const { trackCategoryClick } = useCategoryItemTracking({
    elementType: 'MixedList',
    header: componentConfig.header,
    pageComponentIndex,
  });

  return (
    <List header={header} className={styles.list}>
      {mixed.map((entity, index) => {
        if (isSvpCategory(entity)) {
          return (
            <CategoryItem
              key={`category:${entity.id}`}
              category={entity}
              componentType={componentConfig.type}
              onClick={() => trackCategoryClick(entity, index)}
            />
          );
        }

        return (
          <AssetItem
            key={`asset:${entity.id}`}
            asset={entity}
            componentConfig={componentConfig}
            onClick={() => trackAssetClick(entity, index)}
          />
        );
      })}
    </List>
  );
};

export const MixedList = memo(MixedListBase);
